<template>
  <action-log-template :actionLog="actionLog">
    <template #actionName>
      <p :class="['action-type flex-row flex__left inline-flex']">
        <i :class="iconClass"></i>
        <span class="font-size__small no_wrap color__blue">
          &nbsp;{{ actionNameLabel || "-" }}
        </span>
      </p>
    </template>
  </action-log-template>
</template>

<script>
import convertToLabelFilter from "../../../filters/convertToLabelFilter";
import ActionLogTemplate from "./action-log-template";

export default {
  name: "common-action-log",
  components: {ActionLogTemplate},
  props: ["actionLog", "actionNameLabel", "iconClass"],
  filters: {
    convertToLabelFilter
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/common-action-log.vue